import { type FC } from 'react';
import styled from 'styled-components';

import { ConnectSurface } from '@/components/Pretzel/ConnectSurface';
import { useTexts } from '@/hooks/useTexts';

export const InfoBanner: FC = () => {
  const texts = useTexts();

  return (
    <StyledSurface>
      <IconWrapper>
        <img
          alt="Shield"
          title="Shield"
          src={`${window.config.storeblocksAssetsBaseUrl}/icons/shield-check.svg`}
          height="96px"
          width="96px"
        />
      </IconWrapper>
      <Content>
        <h2>{texts.orders.signatureRight.infoBanner.title}</h2>
        <p className="font-body">
          {texts.orders.signatureRight.infoBanner.description}
        </p>
      </Content>
    </StyledSurface>
  );
};

const StyledSurface = styled(ConnectSurface)`
  display: flex;
`;

const Content = styled.div`
  padding: 16px;
`;

const IconWrapper = styled.div`
  align-items: center;
  padding: 16px;
  display: flex;
`;
